import debounce from 'lodash/debounce'

import api from '@/api'

import {
    VUEX_PREMEDIA_SEARCH_UPDATE_PRODUCT_TERM,
    VUEX_PREMEDIA_SEARCH_GET_PRODUCTS,
    VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_SUCCESS,
    VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_FAILURE, 
    VUEX_PREMEDIA_SEARCH_CLEAR_PRODUCT_DATA,

    VUEX_PREMEDIA_SEARCH_UPDATE_ASSET_TERM,
    VUEX_PREMEDIA_SEARCH_GET_ASSETS,
    VUEX_PREMEDIA_SEARCH_GET_ASSETS_SUCCESS,
    VUEX_PREMEDIA_SEARCH_GET_ASSETS_FAILURE,
	VUEX_PREMEDIA_SEARCH_CLEAR_ASSET_DATA,
	
	VUEX_PREMEDIA_SEARCH_GET_ROWS,
	VUEX_PREMEDIA_SEARCH_GET_ROWS_SUCCESS
} from '@/store/constants/premedia_search'


const state = {
    searchResults: [],
    
    searchProductsData: [],      
	searchProductsTerm: null,    
	searchProductsLoading: false,

	searchAssetsData: [],        
	searchAssetsTerm: null,      
	searchAssetsLoading: false,  
}


const getters = {
	getSearchRowProductItems:(state) => (index) => {
        let data = []
	    if (state.searchResults[index] && state.searchResults[index].items.length>0) {
            data = state.searchResults[index].items.filter((item, i) => {
                if (item.type === 1) {
                    return Object.assign(item, {})
                }
            })
        }
		return data
	},

	getSearchRowAssetItems:(state) => (index) => {
        let data = []
        if (state.searchResults[index] && state.searchResults[index].items.length>0) {
            data = state.searchResults[index].items.filter((item, i) => {
                if (item.type === 2) {
                    return Object.assign(item, {})
                }
            })
        }
		return data
	},
}


const actions = {
	[VUEX_PREMEDIA_SEARCH_UPDATE_PRODUCT_TERM]: async({ commit, dispatch }, payload) => {
		if (!payload) return
		dispatch(VUEX_PREMEDIA_SEARCH_GET_PRODUCTS, payload)
		commit(VUEX_PREMEDIA_SEARCH_GET_PRODUCTS)
	},

	[VUEX_PREMEDIA_SEARCH_GET_PRODUCTS]: debounce(async ({ commit }, payload) => {
        let params = {
            'q': payload,
			'hint': 1,
			'type': 'label' 
		}

		// if (!payload) return
		await api.get(`/premedia-search`, {params}).then((response) => {
            commit(VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_SUCCESS, response.data.data)
		}).catch((err) => {
			commit(VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_FAILURE)
		})	
	}, 500),


	[VUEX_PREMEDIA_SEARCH_UPDATE_ASSET_TERM]: async({ commit, dispatch }, payload) => {
		if (!payload) return
		dispatch(VUEX_PREMEDIA_SEARCH_GET_ASSETS, payload)
		commit(VUEX_PREMEDIA_SEARCH_GET_ASSETS)
	},

	[VUEX_PREMEDIA_SEARCH_GET_ASSETS]: debounce(async ({ commit }, payload) => {
        let params = {
            'q': payload,
            'hint': 1,
			'type': 'filename' 
		}

		// if (!payload) return
		await api.get(`/premedia-search`, {params}).then((response) => {
            commit(VUEX_PREMEDIA_SEARCH_GET_ASSETS_SUCCESS, response.data.data)
		}).catch((err) => {
			commit(VUEX_PREMEDIA_SEARCH_GET_ASSETS_FAILURE)
		})	
	}, 500),


	[VUEX_PREMEDIA_SEARCH_GET_ROWS]:({commit}, payload) => {
		let params = {
            'q': payload.value,
            'hint': 0,
			'type': payload.type
		}
		
		api.get(`/premedia-search`, {params}).then((response) => {
			commit(VUEX_PREMEDIA_SEARCH_GET_ROWS_SUCCESS, response.data.data)
		}).catch((err) => {
			console.error(err)
		})
	}
}


const mutations = {
    // ITS PRODUCTS
	[VUEX_PREMEDIA_SEARCH_GET_PRODUCTS]: (state) => {
		state.searchProductsLoading = true
	},

	[VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_SUCCESS]: (state, payload) => {
        state.searchProductsData = payload
        state.searchProductsLoading = false
	},

	[VUEX_PREMEDIA_SEARCH_GET_PRODUCTS_FAILURE]: (state) => {
		state.searchProductsLoading = false
	},

	[VUEX_PREMEDIA_SEARCH_CLEAR_PRODUCT_DATA]: (state) => {
		state.searchProductsData = []
		state.searchProductsTerm = null
		state.searchProductsLoading = false
	},


	[VUEX_PREMEDIA_SEARCH_GET_ASSETS]: (state) => {
		state.searchAssetsLoading = true
	},

	[VUEX_PREMEDIA_SEARCH_GET_ASSETS_SUCCESS]: (state, payload) => {
		state.searchAssetsData = payload
		state.searchAssetsLoading = false
	},

	[VUEX_PREMEDIA_SEARCH_GET_ASSETS_FAILURE]: (state) => {
		state.searchAssetsLoading = false 
	},

	[VUEX_PREMEDIA_SEARCH_CLEAR_ASSET_DATA]: (state) => {
		state.searchAssetsData = []
		state.searchAssetsTerm = null
		state.searchAssetsLoading = false
	},


	[VUEX_PREMEDIA_SEARCH_GET_ROWS]:(state) => {
		state.searchResults = []
	},

	[VUEX_PREMEDIA_SEARCH_GET_ROWS_SUCCESS]:(state, payload) => {
		state.searchResults = payload
	}
}


export default {
    state,
    getters,
    actions,
    mutations
}